import { Box, Button, CircularProgress } from "@mui/material";
import React, { useMemo, useState } from "react";
import LogoutContainer from "../Layout/LogoutContainer";
import {
  HeaderLeftContent,
  HeaderRightContent,
  PageTitleSubtitle,
  StyledHeader,
} from "../Common/styles/header";
import { platformAdminPermissions } from "../../utils/roles";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import PlatformFeaturesList from "./PlatformFeaturesList";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  a11yProps,
  CustomTabPanel,
  MainTabPanel,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import MobileApp from "./MobileApp/MobileApp";
import { setShowModal } from "../../Redux/reducers/appCustomizationSlice";
import { saveCustomizationData } from "../../Redux/actions/appCustomizationAction";
import BackButton from "../Common/UI/BackButton";

const PlatformConfigTabs = () => {
  const [type, setType] = useState("features");
  const dispatch = useAppDispatch();
  const { id: studyId } = useParams();
  const navigate = useNavigate();
  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions,
  );
  const selectedCategory = useAppSelector(
    (state) => state.appCustomization.category,
  );
  const saveLoading = useAppSelector(
    (state) => state.appCustomization.saveLoading,
  );
  const loading = useAppSelector((state) => state.appCustomization.loading);

  const [searchParams] = useSearchParams();
  const studyName = searchParams.get("study") || "";
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions],
  );

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
  };

  const showModal = () => {
    dispatch(setShowModal(true));
  };

  const handleSave = () => {
    dispatch(saveCustomizationData(studyId, selectedCategory));
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Box
        sx={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box>
      </Box>
      <StyledHeader>
        <Box sx={HeaderLeftContent}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <BackButton onClick={handleBack} />
            <PageTitleSubtitle title={studyName || ""} />
          </Box>
        </Box>
        <Box sx={HeaderRightContent}>
          {type === "mobile" && (
            <>
              {selectedCategory !== "urls" &&
                (!saveLoading ? (
                  <Button
                    variant="contained"
                    onClick={handleSave}
                    disabled={loading || saveLoading}
                  >
                    Save
                  </Button>
                ) : (
                  <CircularProgress />
                ))}
              {selectedCategory === "urls" && (
                <Button variant="contained" onClick={showModal}>
                  Add URL
                </Button>
              )}
            </>
          )}
        </Box>
      </StyledHeader>
      <Box sx={{ p: "0px 40px" }}>
        <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
          <StyledTabs value={type} onChange={handleChange}>
            <StyledTab label="Features" value="features" {...a11yProps(0)} />
            <StyledTab label="Mobile App" value="mobile" {...a11yProps(1)} />
          </StyledTabs>
        </Box>
      </Box>
      <Box sx={{ height: "calc(100% - 204px)", overflow: "auto", p: 2.5 }}>
        <MainTabPanel value={type} index={"features"}>
          <PlatformFeaturesList canEdit={canEdit} />
        </MainTabPanel>
        <CustomTabPanel value={type} index={"mobile"}>
          <MobileApp />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default PlatformConfigTabs;
